<template>
<w-settings-content-template>
  <el-row slot="content" :gutter="20">
    <el-col :span="10">
      <w-rsctype-table ref="rsctypeTable" :managetype-list="managetypeList" @set-rsctype="setRsctype"></w-rsctype-table>
    </el-col>
    <el-col :span="14">
      <w-rsc-table :selected-rsctype-row="selectedRsctypeRow"></w-rsc-table>
    </el-col>
  </el-row>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WRsctypeTable from './components/RsctypeTable';
import WRscTable from './components/RscTable';

export default {
  name: 'WRscSettings',
  components: {
    WSettingsContentTemplate,
    WRsctypeTable,
    WRscTable,
  },
  data() {
    return {
      selectedRsctypeRow: null,
    };
  },
  computed: {
    managetypeList() {
      return this.$store.getters.activeManagetypesToShowForRsc;
    },
  },
  methods: {
    setRsctype(selectedRsctypeRow) {
      this.selectedRsctypeRow = selectedRsctypeRow;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/RscSettings/index.vue